import { FormControl, FormLabel, OutlinedInput, InputProps, FormHelperText } from '@mui/material'

type Props = {
  id: string
  label: string
  helperText?: string
} & InputProps

const TextFieldNN: React.FC<Props> = (props) => {
  const { id, label, helperText, sx, ...inputProps } = props

  return (
    <FormControl fullWidth sx={{ minHeight: 96, ...sx }}>
      <FormLabel
        htmlFor={id}
        sx={{
          textAlign: 'left',
          color: 'black',
          fontWeight: 700,
          mb: '5px',
          fontSize: '14px',
        }}>
        {label}
      </FormLabel>
      <OutlinedInput id={id} {...inputProps} sx={{ height: 48 }} />

      {props.error && helperText && (
        <FormHelperText error={props.error} sx={{ textAlign: 'left' }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default TextFieldNN
